import { Link } from 'react-router-dom'
import type { Episode } from '@/domain/episode'
import { EpisodeThumbnail } from './EpisodeThumbnail'
import { DifficultyBadge } from './DifficultyBadge'

function formatDuration(seconds: number) {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}

export function EpisodeCard({
  episode,
  progressPercent,
  passed,
}: {
  episode: Episode
  progressPercent?: number
  passed?: boolean
}) {
  return (
    <Link
      to={`/episodes/${episode.id}`}
      className="cyber-panel group flex flex-col overflow-hidden transition hover:border-teal-500/40 hover:shadow-lg hover:shadow-teal-500/5"
    >
      <div className="relative">
        <EpisodeThumbnail gradient={episode.thumbnailGradient} title={episode.title} className="h-36 w-full" />
        {passed && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-amber-400 text-sm shadow-lg">
            🏅
          </span>
        )}
      </div>
      {typeof progressPercent === 'number' && progressPercent > 0 && (
        <div className="h-1 w-full bg-white/10">
          <div className="h-1 bg-teal-400" style={{ width: `${progressPercent}%` }} />
        </div>
      )}
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="flex items-center justify-between gap-2">
          <DifficultyBadge difficulty={episode.difficulty} />
          <span className="text-xs text-white/50">{formatDuration(episode.durationSeconds)}</span>
        </div>
        <h3 className="font-display font-semibold text-white group-hover:text-teal-300">{episode.title}</h3>
        <p className="line-clamp-2 text-sm text-white/60">{episode.synopsis}</p>
        <div className="mt-auto flex flex-wrap gap-1.5 pt-1">
          {episode.topicTags.map((tag) => (
            <span key={tag} className="rounded-full bg-white/5 px-2 py-0.5 text-[11px] text-white/50">
              #{tag.replace(/-/g, ' ')}
            </span>
          ))}
        </div>
      </div>
    </Link>
  )
}
